<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <FinancialSettingsList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import FinancialSettingsList from '@/components/settings/FinancialSettingsList'

  export default {
    name: 'Settings',
    components: {
      PageTitle,
      PageRowWrapper,
      FinancialSettingsList
    }
  }
</script>
